module.exports = __webpack_public_path__ + "img/Comunicaciones.7d51860b.webp";